export type GoToTagAction = { kind: 'scroll' } | { kind: 'navigate'; sectionSuperId: string } | { kind: 'blocked'; reason: 'hidden' | 'no-access' };

interface GoToTagTarget {
  id: string;
  hidden?: boolean | null;
  sectionSuperId?: string | null;
}

const cssAttr = (value: string): string => value.replace(/["\\]/g, '\\$&');

export const findTagDomNode = (root: ParentNode, tag: { id: string; onId?: string | null }): HTMLElement | null => {
  const id = cssAttr(tag.id);
  const inline = root.querySelector<HTMLElement>(`[id="${id}"].ixbrl-tag, .ixbrl-tag[id="${id}"]`);
  if (inline) return inline;

  const cell = root.querySelector<HTMLElement>(`[data-tag-ids~="${id}"]`);
  if (cell) return cell;

  if (tag.onId) {
    const carrier = root.querySelector<HTMLElement>(`[data-element-uuid="${cssAttr(tag.onId)}"]`);
    if (carrier) return carrier;
  }

  return null;
};

const BLINK_CLASS = 'tag-blink';

export const blinkTagNode = (node: HTMLElement): void => {
  node.classList.remove(BLINK_CLASS);
  void node.offsetWidth;
  node.classList.add(BLINK_CLASS);
  const onEnd = () => {
    node.classList.remove(BLINK_CLASS);
    node.removeEventListener('animationend', onEnd);
  };
  node.addEventListener('animationend', onEnd);
};

export const scrollToNode = (node: HTMLElement): void => {
  const rect = node.getBoundingClientRect();
  const y = rect.top + window.pageYOffset - window.innerHeight / 2 + rect.height / 2;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

export const resolveGoToTagAction = (tag: GoToTagTarget, currentSectionId: string | null, sectionPermissions: Record<string, unknown>): GoToTagAction => {
  if (tag.hidden) return { kind: 'blocked', reason: 'hidden' };
  if (!tag.sectionSuperId || !(tag.sectionSuperId in sectionPermissions)) {
    return { kind: 'blocked', reason: 'no-access' };
  }
  if (tag.sectionSuperId === currentSectionId) return { kind: 'scroll' };
  return { kind: 'navigate', sectionSuperId: tag.sectionSuperId };
};
